import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";

import {
  BaseCurrencyInput,
  Button,
  Drawer,
  Hairline,
  Input,
  Label,
  Radio,
  Select,
} from "@components";
import { ForEach, If } from "@components/control-statements";
import styles from "@styles/containers/oraculo/oracle-drawer.module.scss";
import { Titles } from "../../variables/Titles";

dayjs.extend(customParseFormat);
require("dayjs/locale/br");

export const CustomerBirthdayForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const [type, setType] = useState(node.range?.type || "eq");
  const [min, setMin] = useState(node.range?.min || null);
  const [max, setMax] = useState(node.range?.max || null);
  const [period, setPeriod] = useState(node.range?.period || "day");
  const [is_not, setIsNot] = useState(node.range?.is_not || false);

  const input_configs = {
    mask: "99/99",
    placeholder: "DD/MM",
    format: "DD/MM",
  };

  const getFreshNode = () => {
    console.log(typeof is_not, is_not);
    return {
      ...node,
      range: {
        type: type,
        period: type == "current_period" ? "month" : period,
        is_not: is_not,
        min: min,
        max: max,
      },
    };
  };

  const changeType = (type) => {
    setType((oldType) => {
      if (oldType != type) {
        setPeriod("day");
        setMin(null);
        setMax(null);
        setIsNot(false);
      }
      return type;
    });
  };

  const validate = () => {
    switch (type) {
      case "in_last":
      case "time_to":
        return Number(min) >= 0 && !!period;
      case "current_period":
        return !!period && is_not !== undefined;
      case "eq":
      case "neq":
        return dayjs(
          min,
          input_configs?.format || "DD/MM/YYYY",
          "br",
          true
        ).isValid();
      case "range":
        const min_date = dayjs(
          min,
          input_configs?.format || "DD/MM/YYYY",
          "br",
          true
        );
        const max_date = dayjs(
          max,
          input_configs?.format || "DD/MM/YYYY",
          "br",
          true
        );
        return (
          min_date.isValid() &&
          max_date.isValid() &&
          min_date.isBefore(max_date)
        );
      default:
        return false;
    }
  };

  const radio_options = [
    { label: "Igual a", value: "eq" },
    { label: "Diferente de", value: "neq" },
    { label: "No período", value: "range" },
    { label: "Nos últimos", value: "in_last" },
    { label: "Tempo até aniversário", value: "time_to" },
    { label: "Faz aniversário este mês", value: "current_period" },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CustomerBirthday}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <div className={styles.scrollContainer}>
        <div className={styles.card}>
          <Label>Defina o uso desta variável:</Label>
          <Hairline solid className="mt-5 mb-20" />
          <RadioGroup
            value={type}
            options={radio_options}
            onChange={(v) => changeType(v)}
          />
        </div>

        <div className={styles.card}>
          <Label>Determine o valor de comparação:</Label>
          <Hairline solid className="mt-10 mb-20" />

          <If cond={["eq", "neq"].includes(type)}>
            <Input
              value={min}
              mask="99/99/9999"
              type="tel"
              placeholder="dd/mm/aaaa"
              onChange={(text) => setMin(text.target.value || 0)}
              className="mb-0"
              {...input_configs}
            />
          </If>
          <If cond={["in_last", "time_to"].includes(type)}>
            <div className="d-flex mt-15">
              <BaseCurrencyInput
                placeholder="Inserir valor"
                className="w-50 mb-0 pt-5"
                precision={0}
                prefix=""
                type="tel"
                value={min}
                onChange={(v) => setMin(v)}
              />
              <Select
                title="Selecione o tempo..."
                className="w-50 ml-15 mb-0 mt-5"
                value={period}
                options={[
                  { label: "Dias", value: "day" },
                  { label: "Meses", value: "month" },
                  { label: "Anos", value: "year" },
                ]}
                onChange={(e) => setPeriod(e.target.value)}
              />
            </div>
          </If>
          <If cond={type === "range"}>
            <div className="d-flex mt-15">
              <div className="d-flex flex-column w-50">
                <Label mini>De</Label>
                <Input
                  placeholder="dd/mm/aaaa"
                  mask="99/99/9999"
                  type="tel"
                  value={min}
                  onChange={(v) => setMin(v.target.value)}
                  className="mb-0"
                  {...input_configs}
                />
              </div>
              <div className="d-flex flex-column w-50 ml-15">
                <Label mini>Até</Label>
                <Input
                  placeholder="dd/mm/aaaa"
                  mask="99/99/9999"
                  type="tel"
                  value={max}
                  onChange={(v) => setMax(v.target.value)}
                  className="mb-0"
                  {...input_configs}
                />
              </div>
            </div>
          </If>

          <If cond={type === "current_period"}>
            <Select
              title="Selecione uma opção..."
              className="mb-0"
              value={is_not ? 1 : 0}
              options={[
                { label: "Sim", value: 0 },
                { label: "Não", value: 1 },
              ]}
              onChange={(e) => setIsNot(+e.target.value == 1)}
            />
          </If>
        </div>
      </div>

      <Footer
        disabled={!validate()}
        onSave={() => onSave(getFreshNode())}
        onRemove={() => onRemove(getFreshNode())}
      />
    </Drawer>
  );
};

const RadioGroup = ({ value, options, onChange }) => {
  return (
    <ForEach
      items={options}
      render={(item) => (
        <Radio
          family="variableType"
          className="mb-10"
          value={item.value}
          checked={value}
          onChange={() => onChange(item.value)}
          text={item.label}
        />
      )}
    />
  );
};

const Footer = ({ disabled, onSave, onRemove }) => {
  return (
    <div className={styles.footer}>
      <Button
        className="w-100"
        onClick={() => onSave()}
        disabled={disabled}
        design="primary"
      >
        Aplicar
      </Button>
      <Button
        design="underline"
        className="mt-20 mb-10"
        onClick={() => onRemove()}
      >
        Remover comparação
      </Button>
    </div>
  );
};
